// extracted by mini-css-extract-plugin
export default {"text":"tjKOqD8pKs_6PisZz_Cb__text___"};